import Money from 'common/components/layout/Money';

import VariantTitle from './VariantTitle';

const CompareAtPrice = (props) => {
  const { variant, settings, showVariantTitle } = props;
  const price = variant.comparePrice || variant.price;
  if (!variant) {
    return null;
  }
  if (!variant.addToCartPrice || variant.addToCartPrice >= price) {
    // This is the regular price - classname c7-product__variant-price
    return (
      <div className="c7-product__variant__price__normal">
        <Money number={price} settings={settings} />{' '}
        {showVariantTitle && <VariantTitle variant={variant} />}
      </div>
    );
  }
  // TODO change class name to be compareAt price with strike-thru on it.  c7-product__variant-compare-at-price
  return (
    <div className="c7-product__variant__price__compare">
      <Money number={price} settings={settings} />
    </div>
  );
};

export default CompareAtPrice;
